import { Component, OnInit } from '@angular/core';
import { FuncionalidadService } from '../../../services/funcionalidad.service';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  categories: any = [];
  isCollapsed = false;
  tipoUsuarioId = 0;

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  constructor(private readonly funcionalidadService: FuncionalidadService) {}

  ngOnInit() {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    this.tipoUsuarioId = infoInicioSesion.Id;
    this.getFuncionalidades();
  }

  async getFuncionalidades() {
    this.funcionalidadService
      .cargarFuncionalidadesPorTipoUsuarioYCategoria(this.tipoUsuarioId, 'Home')
      .subscribe({
        next: data => {
          this.categories.push(...data);
        },
        error: error => {
          console.error('Error al cargar las funcionalidades home', error);
        },
      });
    this.funcionalidadService
      .cargarFuncionalidadesPorTipoUsuarioYCategoria(this.tipoUsuarioId, 'Menu')
      .subscribe({
        next: data => {
          this.categories.push(...data);
        },
        error: error => {
          console.error('Error al cargar las funcionalidades', error);
        },
      });
  }
}
